import {useSelector} from 'react-redux'

import {Offer} from '@vio/core/src/offer/types/offer'
import {Room} from '@vio/core/src/room/types/room'
import {getFirstEligibleDealFreezeRoom} from '@vio/shared/src/dealFreeze/modules/selector'
import {getUserAlreadyFrozeADealCookie} from '@vio/shared/src/dealFreeze/services/cookies'
import {isOfferEligibleForDealFreeze} from '@vio/shared/src/dealFreeze/utils/OfferEligibility'

export interface UseRoomOfferDealFreezeBannerParams {
  shouldShowDealFreezeButton: boolean
  offer: Offer
  room: Room
}

export interface UseRoomOfferDealFreezeBannerResult {
  dealFreezeBannerVisibility: boolean
}

export const useRoomOfferDealFreezeBanner = (
  params: UseRoomOfferDealFreezeBannerParams
): UseRoomOfferDealFreezeBannerResult => {
  const {room, offer, shouldShowDealFreezeButton} = params

  const firstEligibleOffer = room.offers.find(offer =>
    isOfferEligibleForDealFreeze(offer.tags)
  )
  const isFirstDealFreezeOffer = firstEligibleOffer?.id === offer.id

  const firstEligibleDealFreezeRoomId = useSelector(
    getFirstEligibleDealFreezeRoom
  )
  const isUserAlreadyFrozeADeal = getUserAlreadyFrozeADealCookie()

  const dealFreezeBannerVisibility =
    shouldShowDealFreezeButton &&
    isFirstDealFreezeOffer &&
    firstEligibleDealFreezeRoomId === room.id &&
    !isUserAlreadyFrozeADeal

  return {
    dealFreezeBannerVisibility
  }
}
